export const quickDateFilters = ['week', 'month', 'year'];
